var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function Subnav(el) {
  var $el = $(el),
      $toggle = $el.find('.subnav__default');

  $toggle.on('click', function() {
    $(this).toggleClass('open');
    $(this).next().toggleClass('open');
  });

}

module.exports = Subnav;
